export default __webpack_public_path__ + "static/media/3.f78c9186.png";